import React from 'react'
import './services.css'
import {FiCheck} from 'react-icons/fi'

const Services = () => {
  return (
    <section id="services">
      <h5>What I do</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className='service'>
         <div className="service__head">
          <h3>AI/ML Models</h3>
         </div>
         <ul className='service__list'>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Develop training models for datasets.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Utilize Q-learning to help agents learn optimal path.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Devise complex algorithms such as Randomized Hill Climbing to solve problems.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Use complex libraries like BERT to assist in natural language processing.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Solve difficult satisfication problems by finding optimal solution.</p>
          </li>
         </ul>
        </article>
        {/*AI/Ml end*/}
        <article className='service'>
         <div className="service__head">
          <h3>Software Development</h3>
         </div>
         <ul className='service__list'>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Plan and design projects for full stack applications.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Create UI/UX designs for frontend.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Handle RESTful APIs using modern frameworks like Java Spring Boot.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Manage and store data using DBMS such as MongoDB and MySQL</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Maintain version control of the code using GitLab.</p>
          </li>
         </ul>
        </article>
        {/*SDE end*/}
        <article className='service'>
         <div className="service__head">
          <h3>Problem Solving</h3>
         </div>
         <ul className='service__list'>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Analyze the given problem and understand it.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Communicate well with clients to understand their needs.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Suggest great ideas to clients to help bring a better product.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Try to find most optimal solutions to problems.</p>
          </li>
          <li>
           <FiCheck className='service__list-icon'/>
           <p>Utilize other resources out there if need be.</p>
          </li>
         </ul>
        </article>
        {/*PS end*/}
      </div>
    </section>
  )
}

export default Services